export default __webpack_public_path__ + "static/media/avatar.a94e4980.svg";